import { lazy } from 'react';


export const VacancyResume = lazy(() => import('./VacancyResume'));
